export default __webpack_public_path__ + "static/media/today.4cadfaad.png";